/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Published1Inputs */

const vi_cmspost_published1 = /** @type {(inputs: Cmspost_Published1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng bài. Website cập nhật trong khoảng 1 phút.`)
};

/**

* @param {Cmspost_Published1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_published1 = /** @type {((inputs?: Cmspost_Published1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Published1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_published1(inputs)
});
export { cmspost_published1 as "cmsPost_published" }